<template>
  <i :class="`ims-icon material-icons size-${size} text-${color}`">
    {{
    icon || name
    }}
  </i>
</template>

<script>
export default {
  props: {
    icon: {
      type: String,
      default() {
        return "face";
      }
    },
    name: {
      type: String,
      default() {
        return "face";
      }
    },
    size: {
      type: String,
      default() {
        return "md";
      }
    },
    color: {
      type: String,
      default() {
        return "";
      }
    }
  }
};
</script>

<style lang="scss">
.ims-icon {
  &.size-xs {
    font-size: 12px;
  }
  &.size-sm {
    font-size: 18px;
  }
  &.size-md {
    font-size: 24px;
  }
  &.size-lg {
    font-size: 32px;
  }
  &.size-xl {
    font-size: 48px;
  }
}
</style>
